/* ============
 * Purchase Transformer
 * ============
 */

import Transformer from './transformer';
import productTrans from './purchaseProduct';
import warehouseTrans from './warehouse';
import purSTrans from './purchaseStatus';
import clientTransformer from './client';

export default class PurchaseTransformer extends Transformer {

  static fetch(adj) {
    return {
      id: adj.id,
      supplierId: adj.supplier_id,
      producerId: adj.producer_id,
      comments: adj.comments,
      purchaseNumber: adj.purchase_number,
      total_qty: adj.total_qty,
      code: adj.code,
      name: adj.name,
      warehouseId: adj.warehouse_id,
      createdAt: adj.created_at,
      products: adj.products !== undefined ? productTrans.fetchCollection(adj.products) : [],
      warehouse: adj.warehouse !== undefined ? warehouseTrans.fetch(adj.warehouse) : [],
      warehouseName: adj.warehouse_name,
      supplier: adj.supplier !== undefined ? clientTransformer.fetch(adj.supplier) : [],
      supplierName: adj.supplier_name,
      status: adj.status,
      purchaseStatus: adj.purchase_status !== undefined ? purSTrans.fetch(adj.purchase_status) : [],
      expectedDeliveryDate: adj.expected_delivery_date,
      receiveDate: adj.receive_date,
      hashId: adj.hash_id,
      userLang: adj.user_lang,
    };
  }

  static send(adj) {
    return {
      supplier_id: adj.supplierId,
      warehouse_id: adj.warehouseId,
      products: productTrans.sendCollection(adj.products),
      comments: adj.comments,
      purchase_number: adj.purchaseNumber,
      status: adj.status,
      name: adj.name,
      expected_delivery_date: adj.expectedDeliveryDate,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/purchase.js